import React from 'react';
import styled from 'react-emotion';

import {
  animateTranslateUp,
  classes as cn
} from 'shared/styles';
import {
  BASE_COLOR as BC
} from 'shared/constants/colors';
import {
  NODE_TYPE as NT,
  MARK_TYPE as MT,
} from 'shared/constants/slate';
import { noop } from 'shared/helpers';

import { cx, sx } from 'helpers';
import { SvgIcon, Tooltip } from 'components/elems';

// in pixels
const FORMAT_BUTTON_SIZE = 14;
const HOVER_MENU_WIDTH = (FORMAT_BUTTON_SIZE * 2) * 4;
// const HOVER_MENU_WIDTH = 220;
const HOVER_MENU_HEIGHT = 28;
// const HOVER_MENU_INPUT_WIDTH = HOVER_MENU_WIDTH - 40;




const notClickable = {
  cursor: 'default',
  pointerEvents: 'none',
};

const styleSetByTheme = {
  dark: {
    active: { color: BC.caretBlue },
    inactive: { color: BC.nearWhite },
    disabled: { color: BC.midLightGray, ...notClickable },
  },
  light: {
    active: { color: BC.caretBlue },
    inactive: { color: BC.darkGray },
    disabled: { color: BC.midLightGray, ...notClickable },
  },
};

const FormatButton = ({
  // title,
  className,
  style = {},
  children,
  isActive = false,
  isDisabled = false,
  theme = 'light',
}) => {
  const commonStyle = { transition: 'all 200ms' };

  const styleSet = styleSetByTheme[theme] || styleSetByTheme.dark;
  const { active, inactive, disabled } = styleSet;
  const engagedStyle = (isDisabled
    ? disabled
    : (isActive ? active : inactive)
  );

  return (
    <div
      className={cx(
        "bn pointer -inline-flex-cc",
        className,
      )}
      style={sx(style, commonStyle, engagedStyle)}
    >
      {children}
    </div>
  );
};

const FormatButtonFrame = styled('div')(props => ({
  width: props.size * 2,
  height: props.size * 2,
}));


const makeButton = (Icon, title) => ({ size = FORMAT_BUTTON_SIZE, ...props }) => {
  const {
    onMouseDown,
    isDisabled,
    withTooltip = true,
  } = props;

  return (
    <FormatButtonFrame
      onMouseDown={isDisabled ? noop : onMouseDown}
      className={cx("-flex-cc pointer hover-bg-near-white")}
      data-tip={withTooltip ? title : null}
      size={size}
    >
      <FormatButton
        {...props}
        style={{ width: size, height: size, }}
        title={title}
      >
        <Icon size={size} />
      </FormatButton>

      {withTooltip && (
        <Tooltip
          effect="solid"
          place="top"
          globalEventOff='click'
          multiline={true}
          className={cn.tooltipTiny}
        />
      )}
    </FormatButtonFrame>
  );
}

// Make it little heading, big Headling
const makeHeadingButton = (level = 1, title) => ({ size = 14, ...props }) => (
  <FormatButton
    {...props}
    className="ph1"
    style={{
      fontFamily: 'Times, Times New Roman, serif',
      fontSize: size,
      width: size,
      height: size,
    }}
    title={title}
  >
    <span>H{level}</span>
  </FormatButton>
);


const BoldFormatButton = makeButton(SvgIcon.fa.Bold, 'Bold');
const ItalicFormatButton = makeButton(SvgIcon.fa.Italic, 'Italic');
const StrikethruFormatButton = makeButton(SvgIcon.fa.Strikethru, 'Strikethrough');
const CodeFormatButton = makeButton(SvgIcon.fa.Code, 'Code');

const QuoteFormatButton = makeButton(SvgIcon.fa.QuoteRight, 'Blockquote');
const LinkFormatButton = makeButton(SvgIcon.fa.Link, 'Link');
const HeadingOneButton = makeHeadingButton(1, 'Heading 1');
const HeadingTwoButton = makeHeadingButton(2, 'Heading 2');

const formatTypeToButtonMap = {
  // Marks
  [MT.bold]: BoldFormatButton,
  [MT.italic]: ItalicFormatButton,
  [MT.strikethrough]: StrikethruFormatButton,
  [MT.code]: CodeFormatButton,

  // Inlines
  [NT.link]: LinkFormatButton,

  // Special Blocks
  [NT.blockquote]: QuoteFormatButton,
  [NT.headingOne]: HeadingOneButton,
  [NT.headingTwo]: HeadingTwoButton,
};


const renderFormatBtn = (type, onMouseDown, status, props = {}) => {
  const Button = formatTypeToButtonMap[type];
  const { isActive, isDisabled } = status;

  return (Button
    ? <Button
        key={`HoverMenu-btn-${type}`}
        isActive={isActive}
        isDisabled={isDisabled}
        onMouseDown={onMouseDown}
        {...props}
      />
    : null
  );
};


const HoverMenuFrame = styled('div')(props=> ({
  zIndex: 2,
  display: 'flex',
  background: BC.white,
  opacity: props.isVisible ? 1 : 0,
  marginTop: '-20px',
  transition: 'animation 350ms, all 50ms',
  boxShadow: `${BC.moonLightGray} 0px 6px 20px`,
  borderRadius: '.25rem', // br2
  ...animateTranslateUp,

  // Tiny pointy thing at the bottom
  // '&:after': {
  //   content: "''",
  //   position: 'absolute',
  //   left: '50%',
  //   bottom: '-12px',
  //   pointerEvents: 'none',
  //   border: '6px solid transparent',
  //   borderTopColor: BC.white,
  //   marginLeft: '-3px',  // Half of border width
  // },
}));


export {
  HOVER_MENU_WIDTH,
  HOVER_MENU_HEIGHT,
  HoverMenuFrame,
  renderFormatBtn,
  // HoverMenuLinkInput,
}



// WEBPACK FOOTER //
// ./src/components/slate/decors/HoverMenu.js